import { isMobile } from "react-device-detect";

import LeftImg from "../../images/leftPeople.png";
import RightImg from "../../images/rightPeople.png";
import Logo from "../../images/giantLogo.png";

import "./we-are.scss";

function WeAre() {
  return (
    <div className="we-are">
      <div className="content">
        <div
          className={`container-fluid container-1 ${isMobile ? "mobile" : ""}`}
        >
          <div className="container">
            <div className="title">
              <h1>Quem somos</h1>
            </div>
            <div className="texts">
              <h4>
                <strong>
                  Sabe aquele brinquedinho que você sempre sonhou para o seu
                  bebê mas nunca comprou porque sabia que logo, logo iria
                  perdê-lo? Ou até comprou, mas o neném não se adaptou?
                </strong>
              </h4>
              <h4>
                Preciso dizer que você nunca esteve sozinho nessa! Sabemos que
                as crianças crescem muito rápido e, diante da frequência desses
                acontecimentos, a Adoleta surgiu como uma nova solução para
                você.
              </h4>
            </div>
          </div>
        </div>
        <div className="images">
          <div className="right-img">
            <img
              src={RightImg}
              className="img-fluid"
              style={isMobile ? { marginTop: "-20px" } : { marginTop: "-50px" }}
              alt="RightImage"
            />
          </div>
          <div className="left-img">
            <img src={LeftImg} className="img-fluid" alt="LeftImage" />
          </div>
        </div>
        <div
          className={`container-fluid container-2 ${isMobile ? "mobile" : ""}`}
        >
          <div
            className={`container d-flex justify-content-between ${
              isMobile ? "flex-column" : ""
            }`}
          >
            <div className="texts">
              <h4>
                Somos uma empresa de aluguel de brinquedos que veio apresentar
                uma forma incrível de proporcionar diversão para os seus filhos,
                gastando bem pouco. Além de ajudar os pais, nossa motivação é
                também incentivar e propagar a economia sustentável do nosso
                planeta através do uso consciente.
              </h4>
              <h4>
                Alugar brinquedos se tornou um excelente investimento pois
                também permite que a criança desenvolva brincadeiras adequadas à
                sua fase atual e o estimula desde cedo a compartilhar, visto
                que, após a devolução, o mesmo brinquedo fará parte da diversão
                de outro criança.
              </h4>
              <div className="title">
                <h1>
                  E então, <br /> vamos juntos nessa?
                </h1>
              </div>
            </div>
            <div className={`logo ${isMobile ? "text-center" : ""}`}>
              <img src={Logo} alt="Logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeAre;
